import { CFormGroup, CLabel } from "@coreui/react";
import { get } from "lodash";
import ErrorText from "../ErrorText/ErrorText";
import { InfoTooltip } from "..";

const SingleInput = ({
  Component,
  name,
  errors,
  values,
  customDefault,
  label,
  labelClassName,
  info,
  className,
  ...rest
}) => {
  return (
    <CFormGroup className={className}>
      {label && (
        <CLabel className={labelClassName} htmlFor={name}>
          {label}
          {!!info && <InfoTooltip content={info} />}
        </CLabel>
      )}
      <Component
        defaultValue={get(values, name) ?? customDefault}
        name={name}
        id={name}
        {...rest}
      />
      {errors && <ErrorText value={get(errors, name)} />}
    </CFormGroup>
  );
};

export default SingleInput;
